import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Award, Download } from "lucide-react";
import { ShareCertificate } from "@/components/ShareCertificate";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CertificateCard = ({ lessonId, done, total, cert, onIssued, getToken }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const auth = async () => ({ Authorization: `Bearer ${await getToken()}` });
  const claim = async () => {
    setError("");
    try { const r = await axios.post(`${API}/premium/lessons/${lessonId}/certificate`, { name }, { headers: await auth() }); onIssued(r.data); }
    catch (e) { setError(e.response?.data?.detail || "Could not issue certificate"); }
  };
  const download = async () => {
    const r = await axios.get(`${API}/premium/lessons/${lessonId}/certificate.svg`, { headers: await auth(), responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `${cert.code}.svg`; a.click(); URL.revokeObjectURL(a.href);
  };
  return <div className="lesson-card cert-card" data-testid="lesson-certificate">
    <div className="panel-head"><span>CERTIFICATE</span><Award size={14}/></div>
    {cert ? <>
      <p className="cert-line">Issued to <b data-testid="certificate-name">{cert.name}</b></p>
      <code className="cert-code" data-testid="certificate-code">{cert.code}</code>
      <button className="download-item" onClick={download} data-testid="certificate-download-button"><Download size={14}/> Download certificate (SVG)</button>
      <ShareCertificate code={cert.code}/>
      <Link to={`/verify/${cert.code}`} className="text-link" data-testid="certificate-verify-link">Public verification page →</Link>
    </> : done < total ? <p className="cert-line" data-testid="certificate-locked">Tick all {total} checklist items to unlock your certificate ({done}/{total}).</p> : <>
      <label className="edit-field">Name on certificate<input value={name} maxLength={60} onChange={e => setName(e.target.value)} placeholder="Your full name" data-testid="certificate-name-input"/></label>
      {error && <div className="form-error" data-testid="certificate-error">{error}</div>}
      <button className="btn btn-primary" onClick={claim} data-testid="certificate-claim-button"><Award size={15}/> Claim certificate</button>
    </>}
  </div>;
};
